// extracted by mini-css-extract-plugin
export default {"customScroll":"AiPacakging_customScroll__jk6NR"};